//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AuthorizedApiClientBase } from "../../../../components/Auth/AuthorizedApiClientBase";

export class PropertyClient extends AuthorizedApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    calculateRiskCapacity(request: CalculateRiskCapacity_Request): Promise<CalculateRiskCapacity_Response> {
        let url_ = this.baseUrl + "/api/property/risk-calculation/capacity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateRiskCapacity(_response);
        });
    }

    protected processCalculateRiskCapacity(response: Response): Promise<CalculateRiskCapacity_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateRiskCapacity_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateRiskCapacity_Response>(null as any);
    }

    /**
     * @return Success
     */
    calculateRiskTolerance(request: CalculateRiskTolerance_Request): Promise<CalculateRiskTolerance_Response> {
        let url_ = this.baseUrl + "/api/property/risk-calculation/tolerance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCalculateRiskTolerance(_response);
        });
    }

    protected processCalculateRiskTolerance(response: Response): Promise<CalculateRiskTolerance_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateRiskTolerance_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CalculateRiskTolerance_Response>(null as any);
    }

    /**
     * @return Success
     */
    completeInvestmentChecklist(): Promise<any> {
        let url_ = this.baseUrl + "/api/property/investment-checklist/complete";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteInvestmentChecklist(_response);
        });
    }

    protected processCompleteInvestmentChecklist(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    deleteCustomer(userId: string | null): Promise<any> {
        let url_ = this.baseUrl + "/api/property/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteCustomer(_response);
        });
    }

    protected processDeleteCustomer(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    getOnboardingStatus(): Promise<GetOnboardingStatus_Response> {
        let url_ = this.baseUrl + "/api/property/onboarding-status";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOnboardingStatus(_response);
        });
    }

    protected processGetOnboardingStatus(response: Response): Promise<GetOnboardingStatus_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOnboardingStatus_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOnboardingStatus_Response>(null as any);
    }

    /**
     * Get's a summary of property investments that a customer has made
     * @return Success
     */
    getPropertyInvestments(userId: string): Promise<GetPropertyInvestments_Response> {
        let url_ = this.baseUrl + "/api/property/investments/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPropertyInvestments(_response);
        });
    }

    protected processGetPropertyInvestments(response: Response): Promise<GetPropertyInvestments_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPropertyInvestments_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPropertyInvestments_Response>(null as any);
    }

    /**
     * @return Success
     */
    getRiskSummary(): Promise<GetRiskSummary_Response> {
        let url_ = this.baseUrl + "/api/property/risk/summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRiskSummary(_response);
        });
    }

    protected processGetRiskSummary(response: Response): Promise<GetRiskSummary_Response> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRiskSummary_Response.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRiskSummary_Response>(null as any);
    }

    /**
     * @return Success
     */
    skipRiskCalculation(): Promise<any> {
        let url_ = this.baseUrl + "/api/property/risk-calculation/skip";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSkipRiskCalculation(_response);
        });
    }

    protected processSkipRiskCalculation(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    trackCustomerProfile(userId: string | null): Promise<any> {
        let url_ = this.baseUrl + "/api/property/simple-crowdfunding/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTrackCustomerProfile(_response);
        });
    }

    protected processTrackCustomerProfile(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    updateTrackedCustomerProfile(request: UpdateTrackedCustomerProfile_Request, userId: string): Promise<any> {
        let url_ = this.baseUrl + "/api/property/simple-crowdfunding/{UserId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{UserId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTrackedCustomerProfile(_response);
        });
    }

    protected processUpdateTrackedCustomerProfile(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    verifyBlendAccount(): Promise<any> {
        let url_ = this.baseUrl + "/api/property/verify-blend-account";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyBlendAccount(_response);
        });
    }

    protected processVerifyBlendAccount(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    visitBlend(): Promise<any> {
        let url_ = this.baseUrl + "/api/property/visit-blend";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVisitBlend(_response);
        });
    }

    protected processVisitBlend(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Gets the latest self certification for an investor
     * @return Success
     */
    investorCertificationGetSelfCertification(): Promise<InvestorCertificationGetSelfCertification_Response_Root> {
        let url_ = this.baseUrl + "/api/property/investor/self-certificate";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvestorCertificationGetSelfCertification(_response);
        });
    }

    protected processInvestorCertificationGetSelfCertification(response: Response): Promise<InvestorCertificationGetSelfCertification_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorCertificationGetSelfCertification_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestorCertificationGetSelfCertification_Response_Root>(null as any);
    }

    /**
     * Submit self certification for an investor
     * @return Success
     */
    investorCertificationSubmitSelfCertification(root: InvestorCertificationSubmitSelfCertification_Request_Root): Promise<InvestorCertificationSubmitSelfCertification_Response_Root> {
        let url_ = this.baseUrl + "/api/property/investor/self-certificate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(root);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvestorCertificationSubmitSelfCertification(_response);
        });
    }

    protected processInvestorCertificationSubmitSelfCertification(response: Response): Promise<InvestorCertificationSubmitSelfCertification_Response_Root> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvestorCertificationSubmitSelfCertification_Response_Root.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvestorCertificationSubmitSelfCertification_Response_Root>(null as any);
    }
}

export class CalculateRiskCapacity_Response implements ICalculateRiskCapacity_Response {
    score?: number;
    description?: string | undefined;

    constructor(data?: ICalculateRiskCapacity_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CalculateRiskCapacity_Response {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskCapacity_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["description"] = this.description;
        return data;
    }
}

export interface ICalculateRiskCapacity_Response {
    score?: number;
    description?: string | undefined;
}

export class CalculateRiskCapacity_Request implements ICalculateRiskCapacity_Request {
    answers?: CalculateRiskCapacity_Request_Answer[] | undefined;

    constructor(data?: ICalculateRiskCapacity_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(CalculateRiskCapacity_Request_Answer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculateRiskCapacity_Request {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskCapacity_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculateRiskCapacity_Request {
    answers?: CalculateRiskCapacity_Request_Answer[] | undefined;
}

export class CalculateRiskCapacity_Request_Answer implements ICalculateRiskCapacity_Request_Answer {
    question?: CalculateRiskCapacity_Request_Question | undefined;
    reply!: string;
    score!: number;

    constructor(data?: ICalculateRiskCapacity_Request_Answer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"] ? CalculateRiskCapacity_Request_Question.fromJS(_data["question"]) : <any>undefined;
            this.reply = _data["reply"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): CalculateRiskCapacity_Request_Answer {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskCapacity_Request_Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["reply"] = this.reply;
        data["score"] = this.score;
        return data;
    }
}

export interface ICalculateRiskCapacity_Request_Answer {
    question?: CalculateRiskCapacity_Request_Question | undefined;
    reply: string;
    score: number;
}

export class CalculateRiskCapacity_Request_Question implements ICalculateRiskCapacity_Request_Question {
    id!: number;
    text!: string;

    constructor(data?: ICalculateRiskCapacity_Request_Question) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CalculateRiskCapacity_Request_Question {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskCapacity_Request_Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface ICalculateRiskCapacity_Request_Question {
    id: number;
    text: string;
}

export class CalculateRiskTolerance_Response implements ICalculateRiskTolerance_Response {
    score?: number;
    description?: string | undefined;

    constructor(data?: ICalculateRiskTolerance_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CalculateRiskTolerance_Response {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskTolerance_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["description"] = this.description;
        return data;
    }
}

export interface ICalculateRiskTolerance_Response {
    score?: number;
    description?: string | undefined;
}

export class CalculateRiskTolerance_Request implements ICalculateRiskTolerance_Request {
    answers?: CalculateRiskTolerance_Request_Answer[] | undefined;

    constructor(data?: ICalculateRiskTolerance_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(CalculateRiskTolerance_Request_Answer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculateRiskTolerance_Request {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskTolerance_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICalculateRiskTolerance_Request {
    answers?: CalculateRiskTolerance_Request_Answer[] | undefined;
}

export class CalculateRiskTolerance_Request_Answer implements ICalculateRiskTolerance_Request_Answer {
    question?: CalculateRiskTolerance_Request_Question | undefined;
    reply!: string;
    score!: number;

    constructor(data?: ICalculateRiskTolerance_Request_Answer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.question = _data["question"] ? CalculateRiskTolerance_Request_Question.fromJS(_data["question"]) : <any>undefined;
            this.reply = _data["reply"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): CalculateRiskTolerance_Request_Answer {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskTolerance_Request_Answer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question ? this.question.toJSON() : <any>undefined;
        data["reply"] = this.reply;
        data["score"] = this.score;
        return data;
    }
}

export interface ICalculateRiskTolerance_Request_Answer {
    question?: CalculateRiskTolerance_Request_Question | undefined;
    reply: string;
    score: number;
}

export class CalculateRiskTolerance_Request_Question implements ICalculateRiskTolerance_Request_Question {
    id!: number;
    text!: string;

    constructor(data?: ICalculateRiskTolerance_Request_Question) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): CalculateRiskTolerance_Request_Question {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskTolerance_Request_Question();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        return data;
    }
}

export interface ICalculateRiskTolerance_Request_Question {
    id: number;
    text: string;
}

export class GetOnboardingStatus_Response implements IGetOnboardingStatus_Response {
    stages?: GetOnboardingStatus_Response_Stage[] | undefined;

    constructor(data?: IGetOnboardingStatus_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stages"])) {
                this.stages = [] as any;
                for (let item of _data["stages"])
                    this.stages!.push(GetOnboardingStatus_Response_Stage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetOnboardingStatus_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnboardingStatus_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stages)) {
            data["stages"] = [];
            for (let item of this.stages)
                data["stages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetOnboardingStatus_Response {
    stages?: GetOnboardingStatus_Response_Stage[] | undefined;
}

export class GetOnboardingStatus_Response_Stage implements IGetOnboardingStatus_Response_Stage {
    name?: string | undefined;
    order?: number;
    status?: GetOnboardingStatus_Response_StageStatus;

    constructor(data?: IGetOnboardingStatus_Response_Stage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.order = _data["order"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GetOnboardingStatus_Response_Stage {
        data = typeof data === 'object' ? data : {};
        let result = new GetOnboardingStatus_Response_Stage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["order"] = this.order;
        data["status"] = this.status;
        return data;
    }
}

export interface IGetOnboardingStatus_Response_Stage {
    name?: string | undefined;
    order?: number;
    status?: GetOnboardingStatus_Response_StageStatus;
}

export enum GetOnboardingStatus_Response_StageStatus {
    NotStarted = 1,
    InProgress = 2,
    Complete = 3,
}

export class GetPropertyInvestments_Response implements IGetPropertyInvestments_Response {
    deals?: GetPropertyInvestments_Response_Deal[] | undefined;

    constructor(data?: IGetPropertyInvestments_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deals"])) {
                this.deals = [] as any;
                for (let item of _data["deals"])
                    this.deals!.push(GetPropertyInvestments_Response_Deal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPropertyInvestments_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertyInvestments_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deals)) {
            data["deals"] = [];
            for (let item of this.deals)
                data["deals"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetPropertyInvestments_Response {
    deals?: GetPropertyInvestments_Response_Deal[] | undefined;
}

export class GetPropertyInvestments_Response_Deal implements IGetPropertyInvestments_Response_Deal {
    simpleCrowdfundingDealId?: number;
    amountInvested?: number;

    constructor(data?: IGetPropertyInvestments_Response_Deal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.simpleCrowdfundingDealId = _data["simpleCrowdfundingDealId"];
            this.amountInvested = _data["amountInvested"];
        }
    }

    static fromJS(data: any): GetPropertyInvestments_Response_Deal {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertyInvestments_Response_Deal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["simpleCrowdfundingDealId"] = this.simpleCrowdfundingDealId;
        data["amountInvested"] = this.amountInvested;
        return data;
    }
}

export interface IGetPropertyInvestments_Response_Deal {
    simpleCrowdfundingDealId?: number;
    amountInvested?: number;
}

export class GetPropertyInvestments_Request implements IGetPropertyInvestments_Request {

    constructor(data?: IGetPropertyInvestments_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPropertyInvestments_Request {
        data = typeof data === 'object' ? data : {};
        let result = new GetPropertyInvestments_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPropertyInvestments_Request {
}

export class GetRiskSummary_Response implements IGetRiskSummary_Response {
    capacity?: GetRiskSummary_Response_RiskCapacity | undefined;
    tolerance?: GetRiskSummary_Response_RiskTolerance | undefined;
    metadata?: GetRiskSummary_Response_RiskMetadata | undefined;

    constructor(data?: IGetRiskSummary_Response) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.capacity = _data["capacity"] ? GetRiskSummary_Response_RiskCapacity.fromJS(_data["capacity"]) : <any>undefined;
            this.tolerance = _data["tolerance"] ? GetRiskSummary_Response_RiskTolerance.fromJS(_data["tolerance"]) : <any>undefined;
            this.metadata = _data["metadata"] ? GetRiskSummary_Response_RiskMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRiskSummary_Response {
        data = typeof data === 'object' ? data : {};
        let result = new GetRiskSummary_Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capacity"] = this.capacity ? this.capacity.toJSON() : <any>undefined;
        data["tolerance"] = this.tolerance ? this.tolerance.toJSON() : <any>undefined;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetRiskSummary_Response {
    capacity?: GetRiskSummary_Response_RiskCapacity | undefined;
    tolerance?: GetRiskSummary_Response_RiskTolerance | undefined;
    metadata?: GetRiskSummary_Response_RiskMetadata | undefined;
}

export class GetRiskSummary_Response_RiskCapacity implements IGetRiskSummary_Response_RiskCapacity {
    score?: number;
    description?: string | undefined;

    constructor(data?: IGetRiskSummary_Response_RiskCapacity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetRiskSummary_Response_RiskCapacity {
        data = typeof data === 'object' ? data : {};
        let result = new GetRiskSummary_Response_RiskCapacity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetRiskSummary_Response_RiskCapacity {
    score?: number;
    description?: string | undefined;
}

export class GetRiskSummary_Response_RiskTolerance implements IGetRiskSummary_Response_RiskTolerance {
    score?: number;
    description?: string | undefined;

    constructor(data?: IGetRiskSummary_Response_RiskTolerance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.score = _data["score"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GetRiskSummary_Response_RiskTolerance {
        data = typeof data === 'object' ? data : {};
        let result = new GetRiskSummary_Response_RiskTolerance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["description"] = this.description;
        return data;
    }
}

export interface IGetRiskSummary_Response_RiskTolerance {
    score?: number;
    description?: string | undefined;
}

export class GetRiskSummary_Response_RiskMetadata implements IGetRiskSummary_Response_RiskMetadata {
    lowestPossibleScore?: number;
    highestPossibleScore?: number;

    constructor(data?: IGetRiskSummary_Response_RiskMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lowestPossibleScore = _data["lowestPossibleScore"];
            this.highestPossibleScore = _data["highestPossibleScore"];
        }
    }

    static fromJS(data: any): GetRiskSummary_Response_RiskMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new GetRiskSummary_Response_RiskMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lowestPossibleScore"] = this.lowestPossibleScore;
        data["highestPossibleScore"] = this.highestPossibleScore;
        return data;
    }
}

export interface IGetRiskSummary_Response_RiskMetadata {
    lowestPossibleScore?: number;
    highestPossibleScore?: number;
}

export class UpdateTrackedCustomerProfile_Request implements IUpdateTrackedCustomerProfile_Request {
    email?: string | undefined;

    constructor(data?: IUpdateTrackedCustomerProfile_Request) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UpdateTrackedCustomerProfile_Request {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrackedCustomerProfile_Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IUpdateTrackedCustomerProfile_Request {
    email?: string | undefined;
}

export class InvestorCertificationGetSelfCertification_Response_Root implements IInvestorCertificationGetSelfCertification_Response_Root {
    isEligibleForPropertyInvestment?: boolean | undefined;
    expiresOn?: Date | undefined;
    canSubmit?: boolean;

    constructor(data?: IInvestorCertificationGetSelfCertification_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEligibleForPropertyInvestment = _data["isEligibleForPropertyInvestment"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : <any>undefined;
            this.canSubmit = _data["canSubmit"];
        }
    }

    static fromJS(data: any): InvestorCertificationGetSelfCertification_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorCertificationGetSelfCertification_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEligibleForPropertyInvestment"] = this.isEligibleForPropertyInvestment;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : <any>undefined;
        data["canSubmit"] = this.canSubmit;
        return data;
    }
}

export interface IInvestorCertificationGetSelfCertification_Response_Root {
    isEligibleForPropertyInvestment?: boolean | undefined;
    expiresOn?: Date | undefined;
    canSubmit?: boolean;
}

export class InvestorCertificationSubmitSelfCertification_Response_Root implements IInvestorCertificationSubmitSelfCertification_Response_Root {
    isEligibleForPropertyInvestment?: boolean;

    constructor(data?: IInvestorCertificationSubmitSelfCertification_Response_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEligibleForPropertyInvestment = _data["isEligibleForPropertyInvestment"];
        }
    }

    static fromJS(data: any): InvestorCertificationSubmitSelfCertification_Response_Root {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorCertificationSubmitSelfCertification_Response_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEligibleForPropertyInvestment"] = this.isEligibleForPropertyInvestment;
        return data;
    }
}

export interface IInvestorCertificationSubmitSelfCertification_Response_Root {
    isEligibleForPropertyInvestment?: boolean;
}

export class InvestorCertificationSubmitSelfCertification_Request_Root implements IInvestorCertificationSubmitSelfCertification_Request_Root {
    selfCertifiedInvestorType?: InvestorCertificationSelfCertifiedInvestorType;
    selfCertificationConsiderations?: InvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration[] | undefined;

    constructor(data?: IInvestorCertificationSubmitSelfCertification_Request_Root) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selfCertifiedInvestorType = _data["selfCertifiedInvestorType"];
            if (Array.isArray(_data["selfCertificationConsiderations"])) {
                this.selfCertificationConsiderations = [] as any;
                for (let item of _data["selfCertificationConsiderations"])
                    this.selfCertificationConsiderations!.push(InvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InvestorCertificationSubmitSelfCertification_Request_Root {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorCertificationSubmitSelfCertification_Request_Root();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selfCertifiedInvestorType"] = this.selfCertifiedInvestorType;
        if (Array.isArray(this.selfCertificationConsiderations)) {
            data["selfCertificationConsiderations"] = [];
            for (let item of this.selfCertificationConsiderations)
                data["selfCertificationConsiderations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInvestorCertificationSubmitSelfCertification_Request_Root {
    selfCertifiedInvestorType?: InvestorCertificationSelfCertifiedInvestorType;
    selfCertificationConsiderations?: InvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration[] | undefined;
}

export enum InvestorCertificationSelfCertifiedInvestorType {
    HighNetWorth = 0,
    Sophisticated = 1,
    Restricted = 2,
}

export class InvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration implements IInvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration {
    consideration?: PropellePropertyApplicationDomainInvestorCertificationCertifiedConsideration;
    isApplicable?: boolean;

    constructor(data?: IInvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consideration = _data["consideration"];
            this.isApplicable = _data["isApplicable"];
        }
    }

    static fromJS(data: any): InvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration {
        data = typeof data === 'object' ? data : {};
        let result = new InvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consideration"] = this.consideration;
        data["isApplicable"] = this.isApplicable;
        return data;
    }
}

export interface IInvestorCertificationSubmitSelfCertification_Request_SelfCertificationConsideration {
    consideration?: PropellePropertyApplicationDomainInvestorCertificationCertifiedConsideration;
    isApplicable?: boolean;
}

export enum PropellePropertyApplicationDomainInvestorCertificationCertifiedConsideration {
    PreviouslyInvestedMoreThan10PercentInLast12Months = 0,
    WillInvestMoreThan10PercentInNext12Months = 1,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}